var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSend48Filled = function SvgIconSend48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.85 10.15a2.895 2.895 0 0 0-2.92-.72l-21.92 6.89c-2.25.71-3.71 2.7-3.71 5.06 0 2.36 1.46 4.35 3.71 5.06l4.67 1.47 8.7-8.7 2.4 2.4-8.7 8.7 1.47 4.68c.71 2.25 2.69 3.71 5.06 3.71 2.37 0 4.35-1.46 5.06-3.71l6.89-21.92c.33-1.04.05-2.15-.72-2.92h.01Z",
    fill: "current"
  })));
};
export default SvgIconSend48Filled;